// components/ClientContactsTable.jsx
import React from "react";
import Table from "rc-app/components/Table";
import { toTitleCase } from "rc-app/utils";

const ClientContactsTable = ({
  title = "Contacts",
  contacts,
  columns,
  className = "",
  onEdit,
}: any) => {
  // When an onEdit handler is supplied, render Edit as the 4th column with a
  // per-row button (so a specific contact can be edited, not just the first).
  const cols = onEdit ? [...(columns || []), "Edit"] : columns;

  const renderRow = (contacts: any, index: number) => (
    <tr
      key={index}
      className="hover:bg-[#35495E] transition-colors text-[#F4F5F7] text-base border border-[#374B5E]"
    >
      <td className="px-4 py-3  font-semibold">
        <div className="flex items-center gap-2">{toTitleCase(contacts.name, "/[\s._-]+/")  || "Not Available"}</div>
      </td>

      <td className="px-4 py-3 font-normal">
        <div className="flex items-center gap-1">{contacts.mobile_number  || "Not Available"}</div>
      </td>

      <td className="px-4 py-3 text-sm font-medium">
        <div className="flex items-center gap-1">
          <span className="truncate min-w-[160px] w-full">{contacts.email_id  || "Not Available"}</span>
        </div>
      </td>

      {onEdit && (
        <td className="px-4 py-3 text-sm">
          <button
            type="button"
            onClick={() => onEdit(contacts)}
            className="text-[#34D399] hover:text-[#6EE7B7] font-medium"
          >
            Edit
          </button>
        </td>
      )}
    </tr>
  );
  return (
    <Table
      title={title}
      columns={cols}
      data={contacts}
      renderRow={renderRow}
      emptyMessage={`No ${title.toLowerCase()} available`}
      className={className}
      sortableColumns={[0, 1, 2]}
      columnKeys={["name", "mobile_number", "email_id"]}
    />
  );
};

export default ClientContactsTable;
